
const InjectionConsent = (
    {
        physicians,
        MultiSelector,
        InjectionConsentForm,
        setInjectionConsentForm,
        CheckboxGroup,
        DynamicCheckbox,
        Paragraph,
        PatientSignatureImage,
        nextLoader,
        invalidFields,
        handleCheckboxChange,
        formattedDate,
        pageRef,
        pageTitle,
        Header,
        FormHeader,
        RadioGroup,
        TextInput,
        handleInputChange,
        DiagnosisMultiSelect,
        ButtonGroup,
        currentPage ,
        handleNext ,
        isDisabled ,
        handleFormSubmit,
        encId
    }
) => {
    return (
        <> <Header pageTitle={pageTitle} />
            <div ref={pageRef} className="max-w-5xl w-full bg-white px-3 py-5">
                <FormHeader pageTitle={pageTitle} />
                <Paragraph className="mb-2 mt-2">
                    Your condition has been explained by the nurse/tech and the doctor. You have asked questions about your condition and are comfortable with the
                    positive aspects of the intervention outweighing the negatives discussed with you. This consent form is designed to provide a written confirmation of
                    such discussions by recording some of the more significant medical information given to you. If you are unable to read the pr int due to visual disability, it
                    will be read to you by request. It is intended to make you better informed so that you may give or withhold your consent to the proposed procedure(s)
                    1. Doctor: The doctor checked below has explained the condition(s) that exist in my case:
                </Paragraph>
                <Paragraph underline className="mb-2 mt-2">1. Doctor : The doctor checked below has explained the condition(s) that exist in my case:</Paragraph>
                <RadioGroup
                    label=""
                    name="doctor"
                    disabled={isDisabled}
                    selectedValue={InjectionConsentForm.doctor || ""}
                    onChange={(value) => {
                        setInjectionConsentForm((prev) => ({
                            ...prev,
                            doctor: value,
                        }));
                    }}
                    options={physicians}
                    stacked={false}
                />


                <div className="flex gap-4">
                    <Paragraph underline className="mb-2 mt-2">2. Eye Selected:</Paragraph>

                    <DynamicCheckbox
                        label="OD"
                        fieldName="od"
                        id="od"
                        isChecked={InjectionConsentForm.od}
                        onChange={handleCheckboxChange}
                        isDisabled={isDisabled}
                        showError={invalidFields.includes("od")}
                    />

                    <DynamicCheckbox
                        label="OS"
                        fieldName="os"
                        id="os"
                        isChecked={InjectionConsentForm.os}
                        onChange={handleCheckboxChange}
                        isDisabled={isDisabled}
                        showError={invalidFields.includes("os")}
                    />
                </div>

                <Paragraph underline className="text-center">
                    Diagnosis
                </Paragraph>

                <DiagnosisMultiSelect
                    diagnosisList={InjectionConsentForm.diagnosis}
                    onChange={(updated) =>
                        setInjectionConsentForm((prev) => ({
                            ...prev,
                            diagnosis: updated
                        }))
                    }
                    label="Diagnosis"
                    isDisabled = {isDisabled || encId}
                />

                <TextInput
                    id="other_diagnosis"
                    label="Other"
                    value={InjectionConsentForm.other_diagnosis}
                    onChange={handleInputChange}
                    disabled={isDisabled || encId}
                    invalid={invalidFields.includes("other_diagnosis") && !InjectionConsentForm.other_diagnosis}
                />

                <Paragraph underline className="text-center">
                    Procedure
                </Paragraph>

                <CheckboxGroup
                    segMeds={InjectionConsentForm.procedures}
                    label="3. Proposed Procedure(s): I understand that the procedure(s) for evaluating and treating my condition is/are:"
                    onChange={(procedure, value) =>
                        setInjectionConsentForm((prev) => ({
                            ...prev,
                            procedures: {
                                ...prev.procedures,
                                [procedure]: value
                            }
                        }))
                    }
                    cols3={true}
                    semibold={false}
                     isDisabled={isDisabled || encId}
                />

                <TextInput
                    id="other_procedure"
                    label="Other"
                    value={InjectionConsentForm.other_procedure}
                    onChange={handleInputChange}
                    disabled={isDisabled || encId}
                    invalid={invalidFields.includes("other_procedure") && !InjectionConsentForm.other_procedure}
                />





                <div className="flex gap-4">
                    <Paragraph underline>
                        4. Alternative options offered to me were:
                    </Paragraph>

                    <DynamicCheckbox
                        label="Observation"
                        fieldName="alternative"
                        id="alternative"
                        isChecked={InjectionConsentForm.alternative}
                        onChange={handleCheckboxChange}
                        isDisabled={isDisabled}
                        showError={invalidFields.includes("alternative")}
                    />
                </div>

                <Paragraph underline>
                    5. Risks/ Benefits of Proposed Procedure(s):
                </Paragraph>
                <Paragraph>
                    The following have been discussed with me and apply to my condition:
                </Paragraph>

                <ul className="list-none font-medium mb-2 text-black space-y-3">
                    <li className="font-medium text-black pl-4">
                        <span className="font-bold bg-blue-100 px-2 py-1 rounded">A.</span> <span className="font-bold">Lasers:</span> Just as there may be benefits to procedure(s) proposed. I also understand that medical and surgical procedures involve risks.
                        These risks include: 1. Failure to achieve intent of surgery 2. Loss of central or side vision 3. Decreased night vision
                        4. Early or late increase in eye pressure (glaucoma) 5. Corneal bums 6. Damage to lens (cataract) 7. Retina holes 8. Damage to the iris
                        9. Damage to intraocular lens implant, if present
                    </li>
                    <li className="font-medium text-black pl-4">
                        <span className="font-bold bg-blue-100 px-2 py-1 rounded">B.</span> <span className="font-bold">Intravitreal Injection:</span> 1. Elevation or reduction in eye pressure 2. Loss of vision 3. Infection or inflammation inside the eye 4. Need for surgical correction of
                        complications 5. Pain, bleeding, or drooping of eye lid requiring surgery 6. Retina detachment 7. Worsening of cataract, if applicable. 8. Floaters due to
                        silicone oil droplets that lubricate the syringe and will not go away. 9. Off label use of Avastin 10. Loss of vision or loss of eye.
                    </li>
                </ul>

                <Paragraph underline>
                    6. Complications/ Unforeseen Conditions/ Results:
                </Paragraph>
                <Paragraph>
                    The following have been discussed with me and apply to my condition:
                </Paragraph>

                <ul className="list-disc font-medium list-inside mb-2 text-black ">
                    <li className="font-medium text-black pl-4">
                        I am aware that in the practice of medicine, other unexpected risks or
                        complications not discussed may occur. I also understand that during the proposed procedure(s) unforeseen conditions may be
                        revealed requiring the performance of additional procedure(s). I authorize such procedures to be performed. I further acknowledge that
                        no guarantees or promises have been made to me concerning the results of any procedure or treatment.
                    </li>
                </ul>

                {/* Patient Signature + Inventory */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 items-start">

                    {/* Patient Signature */}
                    <div className="min-w-0">
                        <div className="rounded-lg border border-gray-200 bg-white p-2">
                            <PatientSignatureImage
                                signature={InjectionConsentForm.patient_signature}
                                signedDate=""
                                label={`${InjectionConsentForm.first_name} ${InjectionConsentForm.last_name} - ${formattedDate}`}
                            />
                        </div>
                    </div>

                    {/* Inventory */}
                    {InjectionConsentForm.inventory?.length > 0 && (
                        <div className="min-w-0">

                            <div className="grid grid-rows-1 sm:grid-rows-2 gap-3">
                                {InjectionConsentForm.inventory.map((item, index) => (
                                    <div
                                        key={index}
                                        className="rounded-2xl border-2 border-dashed border-blue-300 p-3 flex items-start gap-3 shadow-sm hover:shadow-md transition-shadow"
                                    >
                                        {/* QR */}
                                        {item.qr_code && (
                                            <div className="bg-white rounded-lg p-1.5 flex-shrink-0 shadow-md border border-gray-200">
                                                <img
                                                    src={`data:image/svg+xml;base64,${item.qr_code}`}
                                                    alt={`QR ${index + 1}`}
                                                    className="w-20 h-20"
                                                />
                                            </div>
                                        )}

                                        {/* Details */}
                                        <div className="flex-1 text-[10px] leading-relaxed min-w-0">
                                            {item.eye && (
                                                <div className="inline-block bg-gradient-to-r from-blue-500 to-blue-600 text-white px-2 py-0.5 rounded-full font-bold text-[9px] mb-1.5">
                                                    ✓ {item.eye}
                                                </div>
                                            )}

                                            <div className="flex flex-col gap-1">
                                                <div className="flex gap-1 items-center">
                                                    <span className="text-blue-600 font-semibold flex-shrink-0 text-sm">ID:</span>
                                                    <span className="text-gray-700 font-mono truncate font-bold text-base">{item.inventory_id}</span>
                                                </div>
                                                {item.expiration_date && (
                                                    <div className="flex gap-1 items-center">
                                                        <span className="text-blue-600 font-semibold flex-shrink-0 text-sm">Exp:</span>
                                                        <span className="text-gray-700 font-bold truncate text-base">{item.expiration_date}</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>


                {/* Signatures */}
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3 mt-3">

                    <CheckboxGroup
                        segMeds={InjectionConsentForm.checks}
                        label=""
                        cols2={false}
                        onChange={(check, value) =>
                            setInjectionConsentForm((prev) => ({
                                ...prev,
                                checks: {
                                    ...(prev.checks || {}),
                                    [check]: value
                                }
                            }))
                        }
                    />

                    {/* Tech Signature */}
                    <div className="md:col-span-2 min-w-0 rounded-lg border border-gray-200 bg-white p-3">
                        <div
                            className="w-full flex items-center justify-center text-center overflow-hidden text-ellipsis whitespace-nowrap"
                            style={{
                                fontFamily: '"Brush Script MT", "Lucida Handwriting", cursive',
                                fontSize: '32px',
                                fontStyle: 'italic',
                                fontWeight: 'bold',
                                color: '#333',
                                minHeight: '80px',
                                paddingBottom: '8px',
                                borderBottom: '2px solid #000',
                                lineHeight: '1.2'
                            }}
                        >
                            {InjectionConsentForm.tech_signature}
                        </div>

                        <p className="text-[11px] text-gray-500 mt-2 text-center font-medium">
                            RN Tech Signature
                        </p>
                    </div>

                    {/* Doctor Signature */}
                    <div className="md:col-span-2 min-w-0 rounded-lg border border-gray-200 bg-white p-3">
                        <PatientSignatureImage
                            signature={InjectionConsentForm.doctor_signature}
                            signedDate=""
                            label="M.D Signature"
                        />
                    </div>

                </div>

            </div>
             {/* Footer Buttons */}
                <div className="mt-10">
                    <ButtonGroup
                        isDisabled={isDisabled}
                        currentPage={currentPage}
                        handleNext={handleNext}
                        handleFormSubmit = {handleFormSubmit}
                    />
                </div>
        </>
    );
};

export default InjectionConsent;
